import { httpServiceClient } from '@/infra/http'
import { makeApiUrl, makeUserAccountProfileUrl } from '@/main/factories/http/api-url-factory'
import { ContactType, UserProfileResponse } from './contact-verification-service-types'
import { formatUserProfile } from './contact-verification-service-utils'
import { Account } from '@/domain/usecases'
import { UserInfo } from '@presentation/components/ui/form/contact-verification/contact-verification-btn'
import { formatCustomDateString } from '@/main/helpers'

export const createContactVerificationService = (client = httpServiceClient) => {
  const fetchUserProfile = async () => {
    const pathUrl = makeUserAccountProfileUrl()

    const response = await client<UserProfileResponse>({
      method: 'get',
      url: pathUrl
    })

    const data = response?.body?.data
    if (!data) {
      throw new Error('User profile data not available')
    }

    return formatUserProfile(data as UserProfileResponse)
  }

  return {
    async updateAndFetchUserProfile(
      remoteAccountProfile: Account,
      profileData: Account.PersonalProfileModel
    ) {
      await remoteAccountProfile.updatePersonalProfile(profileData)
      return fetchUserProfile()
    },

    async updateContactInfo(userInfo: UserInfo) {
      const pathUrl = makeApiUrl('/v2/user/account/personal-data')

      const response = await client({
        method: 'patch',
        url: pathUrl,
        body: {
          personal_email: userInfo.personalEmail,
          phone: userInfo.phone,
          birthdate: formatCustomDateString(userInfo.birthdate, 'yyyy-mm-dd')
        }
      })

      return response.body
    },

    fetchUserProfile,

    async sendCode(contactType: ContactType) {
      const pathUrl = makeApiUrl('/account/v2/verification-code/send')

      const response = await client({
        method: 'post',
        url: pathUrl,
        body: {
          contact_type: contactType
        }
      })

      return response.body
    },

    async verifyCode(code: string) {
      const pathUrl = makeApiUrl('/account/v2/verification-code/validate')

      await client({
        method: 'post',
        url: pathUrl,
        body: {
          verification_code: code
        }
      })
    }
  }
}

export const contactVerificationService = createContactVerificationService()
